import apiFetch from "../../api/apiFetch";
import { mapNotification, type AppNotification } from "./types";

export const notificationsAPI = {
  getAll: async (): Promise<AppNotification[]> => {
    const res = await apiFetch("/notifications", { auth: true });
    const list = Array.isArray(res) ? res : (res?.data?.data ?? res?.data ?? []);
    return list.map(mapNotification);
  },

  markRead: (id: string) =>
    apiFetch(`/notifications/read/${id}`, { method: "POST", auth: true }),

  markAllRead: () =>
    apiFetch("/notifications/read-all", { method: "POST", auth: true }),
};
